export const formatmoeda = {
    // directive definition
    bind: function (el, binding) {
        if (binding.value) {
            var value;
            if (typeof binding.value == "number") {
                value = binding.value;
            } else { // if string
                value = binding.value.includes(",") ? Number(binding.value.replace(',', '.')) : Number(binding.value);
            }
            el.innerHTML = "R$ " + value.toFixed(2).toString().replace('.', ',');
        }
        else if (binding.value === 0) {
            el.innerHTML = "R$ 0,00"
        }
        else
            el.innerHTML = '';
    }
}

